module.exports = __webpack_public_path__ + "img/72-l.844c337d.png";